import {useEffect, useRef} from "react";
import {populateAppScript, PopulateAppScriptArgs} from "./populateAppScript";
import {AppParty} from "../types/types";

export const useAppScript = (args: PopulateAppScriptArgs, party: AppParty | null) => {
    const hasRun = useRef(false);
    useEffect(() => {
        if (!party) return;
        let appScriptParty;
        window.party = JSON.parse(JSON.stringify(party));
        appScriptParty = populateAppScript(args);
        if (!appScriptParty) return;
        window.App = {party: appScriptParty};
        if (hasRun.current) return;
        hasRun.current = true;
        console.log("Executing scripts for the first render");
        try {
            for (let script of party.scripts) {
                eval(script);
            }
        } catch (error) {
            console.error("Error executing script:", error);
        }
    }, [party]);
}